import React from 'react';
import benjamin from '../assets/benjamin-hove.jpg'
import './Hero.css'


export default function Hero() {




    return (
        <div className='hero'>

         <div className='hero-image'>
            <div className='hero-ring'></div>
            <img src={benjamin} className="benjamin" alt="benjamin hove"/>
        </div>

        <div className='hero-text'>
         <h1>Hi, I'm <span style={{color:'#73e2ae'}}>Benjamin</span></h1>
        </div>

        <div className='hero-subtext'>
            <h2>I develop and optimize frontend digital user experiences.</h2>
        </div>

        <div className="stack">
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/HTML5_Badge.svg/800px-HTML5_Badge.svg.png" alt="html logo" />
            <img src="https://cdn4.iconfinder.com/data/icons/social-media-logos-6/512/121-css3-512.png" alt="css logo" />
            <img src="https://static.vecteezy.com/system/resources/previews/027/127/463/original/javascript-logo-javascript-icon-transparent-free-png.png" alt="javascript logo" />
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png" alt="react logo" />
            <img src="https://static-00.iconduck.com/assets.00/node-js-icon-454x512-nztofx17.png" alt="node logo" />
        </div>

       

       
         
           
        </div>
    )
}